import { render, staticRenderFns } from "./sysDd.vue?vue&type=template&id=8a6fa122&scoped=true&"
import script from "./sysDd.vue?vue&type=script&lang=js&"
export * from "./sysDd.vue?vue&type=script&lang=js&"
import style0 from "./sysDd.vue?vue&type=style&index=0&id=8a6fa122&lang=scss&scoped=true&"
import style1 from "./sysDd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fa122",
  null
  
)

export default component.exports